export class MatchingFundHelper {
  static locallyActiveMatchingFund(project) {
    if (project &&
        project.active_matching_fund &&
        !project.active_matching_fund.client_id) {
      return project.active_matching_fund
    }
  }
}
